export default __webpack_public_path__ + "static/media/partner6.3bcedc8c.jpg";